import { render, staticRenderFns } from "./material-list.vue?vue&type=template&id=8f472e6c&scoped=true"
import script from "./material-list.vue?vue&type=script&lang=js"
export * from "./material-list.vue?vue&type=script&lang=js"
import style0 from "./material-list.vue?vue&type=style&index=0&id=8f472e6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f472e6c",
  null
  
)

export default component.exports